define.alias("shared/components/shared/linkinbio/modal/multi-link", "settings/components/shared/linkinbio/modal/multi-link");